import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id DAC4946E-1A07-44B4-977F-E51D740DA5FB
 * name bank-minus
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bank-minus.svg
 * tags
 * - Banking 
 */
export const BankMinusIcon = createSvgIcon(<><path d="M14,17H22V19H14V17M11.5,1L21,6V8H2V6L11.5,1M16,10H19V12.08L18,12C17.3,12 16.63,12.12 16,12.34V10M2,22V19H12.08C12.27,20.14 12.79,21.17 13.53,22H2M10,10H13V14.68C12.54,15.37 12.22,16.15 12.08,17H10V10M4,10H7V17H4V10Z" /></>, 'BankMinusIcon');
export default BankMinusIcon